/* istanbul ignore file */

import { useContext } from 'react';
import { makeStyles } from '@mui/styles';
import SearchContext from './SearchContext';
import TopBar from './TopBar';
import PeopleList from './PeopleList';
const useStyles = makeStyles(({
  spacing,
  breakpoints
}) => ({
  container: {
    marginLeft: spacing(2),
    marginRight: spacing(2),
    marginTop: spacing(3),
    height: '100%'
  },
  [breakpoints.up('md')]: {
    container: {
      maxWidth: 704,
      marginLeft: '25%',
      marginRight: '25%'
    }
  }
}));
export default function PeoplePicker({
  translations = {
    inputSearchLabel: 'Search people',
    inputSearchPlaceholder: 'ie: Alec Dean',
    resetButtonLabel: 'Reset query',
    cancelButtonLabel: 'Cancel search',
    toggleSearchFieldLabel: () => 'Toggle search field',
    noResults: 'No people found',
    loadMore: 'Load more',
    typeSomething: 'Type something',
    confirmSelection: 'Confirm',
    suggested: 'Suggested',
    /* istanbul ignore next */
    resultCount: ({
      peopleCount
    }) => `${peopleCount} people`
  },
  onCancel = () => {},
  onConfirmSelected = () => {},
  noPeoplePage = <div>No people page</div>,
  isLoadMoreDisabled = false,
  suggestedExpert = null
}) {
  const classes = useStyles();
  const {
    hasEmptyPeopleList
  } = useContext(SearchContext);
  const shouldDisplayEmptyState = hasEmptyPeopleList && !suggestedExpert;
  return <>
      <TopBar onCancel={onCancel} onConfirmSelected={onConfirmSelected} translations={translations} />
      <div className={classes.container} role="region" aria-live="polite">
        {shouldDisplayEmptyState ? noPeoplePage : <PeopleList translations={translations} suggestedExpert={suggestedExpert} isLoadMoreDisabled={isLoadMoreDisabled} />}
      </div>
    </>;
}